<div class="alert alert-success" *ngIf="alertSuccess">
  Demographic saved successfully
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  Demographic name already exists
</div>
<div class="alert alert-success" *ngIf="alertUpdate">
  Demographic updated successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
  </div>	
<form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">
  <div>
      <h5>CREATE DEMOGRAPHICS</h5>
  </div>

  <!-- <div class= "row justify-content-center align-items-center"> -->
  <div class="main-section">
  <div class="form-group">
    <label for="demographicsName">Demographics Name</label>
    <p>*</p>
    <input type="text" class="form-control " id="demographicsName" name="demographicsName" required pattern=".*\S+.*" maxlength="50" [(ngModel)]="demographicsName" required>
  </div>

  <div class="form-group">
    <label for="demographicDesc">Description</label>
    
    <textarea class="form-control" id="demographicDesc" name="demographicDesc" maxlength="500" [(ngModel)]="demographicDesc"></textarea>
  </div>
  </div>


  <input type="text" class="form-control" name="id" [(ngModel)]="demograhicId" style="display: none">

  <div class="btn-div">
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==false && savebtn == true" [disabled]="!myForm.valid">SAVE</button>
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==true && savebtn == false" [disabled]="!myForm.valid">SAVE AND UPDATE</button>
  <!-- <span class="col-md-6"></span> -->
  <button type="button" class="btn btn-danger" (click)="resetDemographics()">RESET</button>
</div>
</form>

<!-- <span [(ngModel)]="demographicsData">{{demographicsData}}</span> -->

<!--table-->

<div class=" table-container" *ngIf="demographicsData.length > 0">
<table aria-describedby="table" class="table table-hover table-bordered table_width" id="tabledemo">
<thead>
  <tr class="tr-th">
    <th scope="col">Demographics Name</th>
    <th scope="col">Demographics Description</th>
    <th scope="col" class="col-display">Created By</th>
    <th scope="col" class="col-display">DemographicId</th>
    <th scope="col">Actions</th>
  </tr>
</thead>
<tbody>
    <tr *ngFor="let data of demographicsData">
        <td>{{data.demographicsName}}</td>
        <td>{{data.demographicDesc}}</td>
        <td class="col-display">{{data.createdBy}}</td>
        <td class="col-display">{{data.demograhicId}}</td>
        <td>
          <a (click)="editDemographics(data)" class="edit-delete">Edit</a>
          <a class="edit-delete" (click)="deleteDemographics(data)" style="display: none">Delete</a>
        </td>
        
      </tr>
  <!-- <tr>
    <td>Mary</td>
    <td>Moe</td>
    <td>mary@example.com</td>
  </tr>
  <tr>
    <td>July</td>
    <td>Dooley</td>
    <td>july@example.com</td>
  </tr> -->
</tbody>
</table>
</div>